module.exports = __webpack_public_path__ + "static/images/monet/left_panel_item_line_spacer.gif";